import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import MappingList from '../call/route/MappingList';

type FacilityRoutingTabProps = {
  facility: Facility;
};

const FacilityRoutingTab: React.FC<FacilityRoutingTabProps> = ({ facility }) => {
  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div className="content">
        <MappingList facility={facility} />
      </div>
    </div>
  );
};

export default FacilityRoutingTab;
